import { AxiosRequestConfig } from 'axios';
import { getCookie } from '@/util/cookie/cookie';

const tokenRequiredPath = ['/api/v2', '/api/v3'];

/**
 * @param url axiosに渡されたURL。https://から始まるフルパスと、ホストまでを除いた /api/v2/xxx のどちらかが渡される
 */
const isCsrfTokenRequired = (url: string): boolean => {
  let path = url;
  // /api,api
  if (path.startsWith('api')) {
    path = `/${path}`;
  }

  if (path.startsWith('https://') || path.startsWith('http://')) {
    // フルパスの場合は、ホストまでを除いたパスを取得する
    const urlObj = new URL(path);
    path = urlObj.pathname;
  }

  return tokenRequiredPath.some((requiredPath) => path.startsWith(requiredPath));
};

export const setCsrfTokenHeader = (request: AxiosRequestConfig): AxiosRequestConfig => {
  // CSRFトークンが必要でない場合は何もしない
  if (!isCsrfTokenRequired(request.url || '')) {
    return request;
  }

  const token = getCookie('CODMON-CSRF-TOKEN');
  if (!token) {
    return request;
  }
  request.headers['Codmon-CSRF-Token'] = token;
  return request;
};
